import { AxiosResponse } from "axios";
import Vue from "vue";
import { ILoadResponse } from "@/interfaces";

export const Load = async (): Promise<ILoadResponse> => {
  const resp: AxiosResponse = await Vue.axios({
    method: "POST",
    data: {},
    params: {
      action: "load"
    }
  });
  return resp.data;
};
